const ChartDataCheck = (props) => {
  if (props.isLoading)
    return <div className="loading-data-label">Loading...</div>;

  if (!props.chartData.length) {
    return (
      <div className="no-data-label">
        No data available for the selected countries. Please select different
        countries.
      </div>
    );
  }

  return <>{props.children}</>;
};

export default ChartDataCheck;
